declare var google: any;
declare let Flickity: any;

import { Component, OnInit, ViewChild, AfterViewInit, EventEmitter, NgZone } from '@angular/core';
import { MapsAPILoader, GoogleMapsAPIWrapper, AgmMap, AgmMarker, MarkerManager } from '@agm/core';
import { Router, NavigationEnd, ActivatedRoute, NavigationExtras } from '@angular/router';
import { PlacesSearch } from '../../services/places-search/places-search';
import { SharedPreferencesService } from '../../services/shared-preferences.service';
import { MapProps } from '../../utilities/map.props';
import { Helpers } from '../../utilities/helpers';
import { environment } from '../../../../environments/environment';
import _ from "lodash";

@Component({
  selector: 'app-around-me',
  templateUrl: './around-me.component.html',
  styleUrls: [
  './around-me.component.scss'
  ]
})
export class AroundMeComponent implements OnInit, AfterViewInit {
  @ViewChild(AgmMap) agmMap;
  public selectedLocation: any;
  public selectedCategory: any;
  public selectedPlace:any;
  public lat: number;
  public long: number;
  public places: Array<any> = [];
  public mapStyles: any;
  public latlngbounds: any;
  public map: any = null;
  public flktyCarouselListing: any;
  public screenWidth: number;
  public isMobile: boolean = false;
  public placesLoaded: Boolean = false;
  public zoom: number = environment.places_search.zoom;
  public toastMessage: string;
  public showToast: Boolean = false;
  public hideMessage: Boolean = false;
  public radius: number;
  public autoAdjustMarkers: Boolean = false;
  public lastPanEnd: number = null;
  public hoveredPlace: any = null;
  public isFirstRequest: Boolean = true;
  public isAddressBarVisible: Boolean;
  public markerManager: MarkerManager;
  public currentLocation: any = null;
  public zoomApiTriggered: Boolean = false;
  public routerEventSubscription: any;
  public gMarkers: Object;
  constructor(
    private placesSearch: PlacesSearch,
    private mapsAPILoader: MapsAPILoader,
    public sharedPreferencesService: SharedPreferencesService,
    public router: Router,
    public route: ActivatedRoute,
    private mapsWrapper:GoogleMapsAPIWrapper,
    private zone: NgZone
  ) {
    // window.scrollTo(0,1);
    this.mapsAPILoader.load().then(() => {
      this.mapLoaded();
    })
    this.sharedPreferencesService.showHeader = true;
    this.sharedPreferencesService.showMapCategoryToggle = true;
    this.mapStyles = MapProps.mapStyles();
    this.screenWidth = window.innerWidth;
    window.addEventListener('resize', (event) => {
      this.screenWidth = window.innerWidth;
      this.setMobileFlag();
    })
    this.setMobileFlag();
  }

  setMobileFlag() {
    if(this.screenWidth <= 767) {
      this.isMobile = true;
    }
  }

  mapLoaded() {
    this.initializeLatLongBounds();
  }

  initializeLatLongBounds() {
    this.latlngbounds = new google.maps.LatLngBounds();
  }

  goToApp ()
    {
      this.openLink("https://go.lbb.in/dPNr/YExHjCORaK");
    }

  renderPlaces(lat, long, radius, lastPanEnd) {
    this.zone.run(() => {
      this.placesLoaded = false;
      this.places = [];
      // this.toastMessage = `Loading...`;
      // this.showToast = true;
      radius = radius ? radius : this.selectedLocation.radius;
      this.radius = radius;
      this.placesSearch
        .getPlacesNearBy(lat, long, this.selectedCategory.search_param, radius)
        .subscribe(
        (data) => {
          // this.showToast = false;
          let response = data.json();
          this.initializeLatLongBounds();
          if((this.lastPanEnd > lastPanEnd)) { 
            return;
          }

          if(response.hits.length) {
            this.places = response.hits;
            if(this.autoAdjustMarkers) {  
              for(let place of this.places) {
                let latLong = new google.maps.LatLng(place.location.coordinates.lat, place.location.coordinates.lon);
                this.latlngbounds.extend(latLong);
              }
              this.map.fitBounds(this.latlngbounds);

              this.zoomApiTriggered = true;

              this.mapChanged()

              this.autoAdjustMarkers = false;
            }
          }
          this.placesLoaded = true;
          this.hideMessage = !! this.places.length;
          this.isFirstRequest = false;

        },
        (fail) => {
          this.toastMessage = "Some error occured while getting the data, try refreshing the page";
          // this.placesLoaded = true;
          console.log(fail);
        }
      )
    })
  }
  
  renderFlickity() {
    let carouselListing = document.querySelector('.carousel-listing');
    let objHeroCarousel;

    if(this.isMobile == true) {
      objHeroCarousel = {
        cellAlign: 'left',
        pauseAutoPlayOnHover: false,
        pageDots: false
      }
    } else {
      objHeroCarousel = {
        cellAlign: 'center',
        pauseAutoPlayOnHover: false,
        pageDots: false
      }
    }

    this.flktyCarouselListing = new Flickity(carouselListing, objHeroCarousel);
  }

  ngAfterViewInit() {
    this.agmMap.mapReady.subscribe(map => {
      this.map = map;
      
      if(!this.isMobile){
        this.map.setOptions({ zoomControlOptions: { position: google.maps.ControlPosition.RIGHT_TOP } })
      } else {
        this.map.setOptions({ zoomControl: false })
      }
     

      this.map.addListener('dragend', () => {
        this.searchAfterTwoSeconds();
        // this.toast(`Please wait`, 1500)
      })

      this.map.addListener('dragstart', () => {
        this.lastPanEnd = Helpers.getCurrentTimestamp();
      })

      this.map.addListener('zoom_changed', (event) => {
        if(! this.zoomApiTriggered && ! this.autoAdjustMarkers) {
          this.searchAfterTwoSeconds();
          //this.toast(`Please wait`, 1500)
        }
        this.zoomApiTriggered = false;
      })
      
    });
  }

  ngOnInit() {
    this.initializeView();
    /**
     * This was required because if its the same route then Angular doesnt trigger 'ngOnInit' event
     * In this case since GET params are different we have to reinitialize the View.
     */
    this.routerEventSubscription = this.router.events.subscribe((val) => {
      if(val instanceof NavigationEnd) {
        this.initializeView();
      }
    });
  }

  initializeView() {
    this.route.params.subscribe((params) => {
      this.selectedLocation = this.sharedPreferencesService.getLocation('slug', params.city);
      this.selectedCategory = this.sharedPreferencesService.getCategory('slug', params.category);
      var options = Helpers.getHttpParams();
      this.lat = (options.lat)? parseFloat(options.lat) : this.selectedLocation.lat;
      this.long = (options.long)? parseFloat(options.long) : this.selectedLocation.long;
      this.zoom = (options.zoom)? parseInt(options.zoom) : this.zoom;
      this.radius = (options.radius && options.radius != 'null')? parseInt(options.radius) : this.selectedLocation.radius;
      this.autoAdjustMarkers = (options.autoAdjustMarkers && options.autoAdjustMarkers === 'true') ? true : false;
      this.renderPlaces(this.lat, this.long, this.radius, this.lastPanEnd);
    }).unsubscribe();
  }

  searchAfterTwoSeconds() {
    if(! this.isFirstRequest) {
      let pannedOn = this.lastPanEnd = Helpers.getCurrentTimestamp(); 

      setTimeout(() => {
        if(this.lastPanEnd === pannedOn) {
          this.searchThisArea();
        }
      }, 2000) 
    }
  }

  markerClick(place, index) {
    this.selectedPlace = place;
    this.flktyCarouselListing.select(index);
  }

  locate() {
    this.toastMessage = `Getting your location`;
    this.showToast = true;
    Helpers
    .getLocation()
    .then((position: Position) => {
      this.showToast = false;
      this.lat = position.coords.latitude;
      this.long = position.coords.longitude;
      this.currentLocation = { lat:this.lat, long: this.long };
      this.navigate(this.lat, this.long, this.getRadius());
    })
    .catch(() => {
      this.toast(`Error getting your location, seems like LBB can't access your location, please grant access to your location to get awesome recommendations around you.`);
    });

  }

  toast(message, timeout?) {
    this.toastMessage = message;
    this.showToast = true;
    setTimeout(() => { this.showToast = false }, timeout ? timeout : environment.toastTimeout);
  }

  log(...args){
    console.log(args);
  }

  getBoundsRadius(bounds){
    var earthRadius = 6378.8
    
    // degrees to radians (divide by 57.2958)
 
    var northEastLat = bounds.getNorthEast().lat() / 57.2958
    var northEastLong = bounds.getNorthEast().lng() / 57.2958
    var centerLat = bounds.getCenter().lat() / 57.2958
    var centerLong = bounds.getCenter().lng() / 57.2958

    // now getting 'NORTH' Lat long since google maps doesn't give North's lat long directly we had to calc.

    var northLat = northEastLat;
    var northLong = centerLong;

    // distance = circle radius from center to Northeast corner of bounds
    var radiusFromNorth = earthRadius * Math.acos(
      Math.sin(centerLat) * Math.sin(northLat) + 
      Math.cos(centerLat) * Math.cos(northLat) * Math.cos(northLong - centerLong)
      )

    var radius = radiusFromNorth;

    var eastLat = centerLat
    var eastLong = northEastLong;

    var radiusFromEast = earthRadius * Math.acos(
      Math.sin(centerLat) * Math.sin(eastLat) + 
      Math.cos(centerLat) * Math.cos(eastLat) * Math.cos(eastLong - centerLong)
      )

    if(radius > radiusFromEast) {
      radius = radiusFromEast;
    }
    return Math.ceil(radius *1000) // radius in meters
  }

  getRadius() {
    return this.getBoundsRadius(this.map.getBounds());
  }

  searchThisArea() {
    let radiusToSearch = this.getRadius();
    this.navigate(this.lat, this.long, this.getRadius());
  }

  navigate(lat, long, radius) {
    let navigationExtras: NavigationExtras = {
      queryParams: { lat, long, radius }
    };
    
    this.router.navigate(['/around-me', this.selectedLocation.slug, this.selectedCategory.slug], navigationExtras)
  }

  mapChanged() {

    _.debounce(()=>{
      window.dispatchEvent(new CustomEvent('mapChanged', { detail: { lat: this.lat, long: this.long, zoom:this.zoom, radius: this.getRadius() } }));
    }, 300);
  
  }

  generateLink(recommendation) {
    if (recommendation.type == 'Post')
      return 'https://lbb.in/posts/' + recommendation.slug
    else if (recommendation.type == 'Article')
      return `https://lbb.in/${recommendation.provider}/${recommendation.slug}`
    else if (recommendation.type == 'Event')
      return `https://lbb.in/${recommendation.provider}/events/${recommendation._id}`
  }

  getMarkerIcon(place) {

    if(place === this.selectedPlace) {
      return 'assets/images/map-markers/selected/' + this.selectedCategory.icon
    }

    if(place === this.hoveredPlace) {
      return 'assets/images/map-markers/hovered/' + this.selectedCategory.icon
    }

    return 'assets/images/map-markers/' + this.selectedCategory.icon
  }

  hover(place, enabled, index) {
    if(enabled) {
      this.gMarkers[index].setAnimation(google.maps.Animation.BOUNCE);
      // this.hoveredPlace = place;
    } else {
      this.gMarkers[index].setAnimation(null);
    }
  }

  openLink(link){
    window.open(link, '_blank');
  }

  socialShare(link, channel) {
    link = encodeURIComponent("https://maps.lbb.in/");
    switch(channel) {
      case 'facebook' :
        return `https://www.facebook.com/sharer/sharer.php?u=${link}`;
      case 'whatsapp' :

        let url = (this.isMobile)? 'whatsapp://send' : 'https://web.whatsapp.com/send';

        return url + `?text=Check out this place on LBB - ${link}`;
    }
  }

  setMarkerManager(markerManager: MarkerManager) {
    this.markerManager = markerManager;
  }

  markersChanged(markers: AgmMarker[]) {
    this.gMarkers = {};
    for (let i = markers.length - 1; i >= 0; i--) {
      this.markerManager.getNativeMarker(markers[i]).then((gMarker: any) => {
        // gMarker.setAnimation(google.maps.Animation.DROP);
        this.gMarkers[i] = gMarker;
      })
    }
  }

  ngOnDestroy() {
    google.maps.event.clearInstanceListeners(this.map)

    if(this.routerEventSubscription) {
      this.routerEventSubscription.unsubscribe();
    }
    // google.maps.events.clearListeners(this.map, 'drag_start')
    // google.maps.events.clearListeners(this.map, 'drag_end')
  }
}



// WEBPACK FOOTER //
// /Users/jaswantsingh/Documents/GitHub/maps/src/app/core/components/around-me/around-me.component.ts